define(function(require, exports, module) {
    'use strict';

    var BaseView = require('common/base.view');

    /**
     * @class
     * @name BaseReplacerView
     * @extends BaseView
     */
    module.exports = BaseView.extend({
        constructor: function(options) {
            BaseView.apply(this, arguments);

            var replacerCssClass = options.name
                    .replace(/_/g, '-')
                    .toLowerCase() + '-replacer';
            var replacerCssClasses = 'fn-replacer js-replacer '
                + (this.tagName === 'span' ? 'js-replacer-inline ' : ' ')
                + replacerCssClass;

            this.$el.addClass(replacerCssClasses);
        },

        initialize: function(options) {
            this.options = options;
        }
    });
});
